import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";
// import ReactGA from "react-ga";
import App from "./components/app";
import { HashRouter as Router } from "react-router-dom";

if (process.env.NODE_ENV === "development") {
  console.log("TisBest Spend: Loading");
}
let loadTisBest = function () {
  //ReactGA.initialize("UA-6437491-1");
  if (process.env.NODE_ENV === "development") {
    console.log("TisBest Spend: Initializing React component");
  }
  let tisBestSpendApp = document.getElementById("tisBestSpendApp");
  if (tisBestSpendApp) {
    ReactDOM.render(
      <Router>
        <App />
      </Router>,
      tisBestSpendApp
    );
  } else {
    if (process.env.NODE_ENV === "development") {
      console.log("TisBest Spend: No element to insert component into");
    }
  }
};
if (document.readyState === "loading") {
  if (process.env.NODE_ENV === "development") {
    console.log("TisBest Spend: Waiting for document ready state");
  }
  document.addEventListener("DOMContentLoaded", loadTisBest);
} else {
  loadTisBest();
}
